import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  scrollToId?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  scrollToId,
  href = 'https://calendar.app.google/PYPdcRoYne7QrNJA7'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollToId) {
      e.preventDefault();
      document.getElementById(scrollToId)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.a href={scrollToId ? `#${scrollToId}` : href} target={scrollToId ? undefined : '_blank'} rel={scrollToId ? undefined : 'noopener noreferrer'} onClick={scrollToId ? handleClick : undefined} whileHover={{
    scale: 1.04,
    boxShadow: '0px 0px 30px rgba(242, 183, 5, 0.35)'
  }} whileTap={{
    scale: 0.97
  }} className={`inline-block bg-gold text-carbon font-bold py-4 px-8 rounded-md text-center cursor-pointer ${className}`} data-id="element-270">
      {children}
    </motion.a>;
}